module.exports = {
  fi: 'AI for Domain Experts, Industry and Subject Matter Experts with Domain Specific Problems',
  en: 'AI for Domain Experts, Industry and Subject Matter Experts with Domain Specific Problems'
};
